import { GCPrebillingStorageDto, OrderDto, StockDto } from '@billing/app/api'
import { SelectOption } from '@billing/app/models'
import { GCStorageReportMode } from '@billing/app/models/gc-storage-report-mode.enum'
import exportService from '@billing/services/ExportService'
import ordersService from '@billing/services/OrdersService'
import { CompanyStore } from '@billing/stores/CompanyStore'
import { Dayjs } from 'dayjs'
import { action, makeObservable, observable, runInAction } from 'mobx'

export class GCStoragePreBillingUIStore {
  customerId = ''
  from?: Dayjs
  to?: Dayjs
  inboundOrders: OrderDto[] = []
  stockInventories: StockDto[] = []
  ordersToBePreBilled: number[] | null = null
  reportMode: GCStorageReportMode = GCStorageReportMode.Stock

  reportData: GCPrebillingStorageDto[] = []
  loadingReport = false

  constructor(private readonly _customerStore: CompanyStore) {
    makeObservable(this, {
      from: observable,
      to: observable,
      customerId: observable,
      inboundOrders: observable,
      stockInventories: observable,
      ordersToBePreBilled: observable,
      reportMode: observable,
      reportData: observable,
      loadingReport: observable,
      setCustomerId: action,
      setFrom: action,
      setTo: action,
      loadData: action,
      setIdsToSubmit: action,
      setReportMode: action,
      fetchReportData: action,
    })
  }

  async fetchReportData() {
    if (this.customerId === 'All' || !this.from || !this.to) return

    runInAction(() => {
      this.loadingReport = true
    })

    try {
      const result = await exportService.getGcStoragePrebillingData(
        parseInt(this.customerId),
        this.from,
        this.to,
        this.reportMode === GCStorageReportMode.Stock,
      )

      runInAction(() => {
        this.reportData = result.data
      })
    } catch (error) {
      console.error('Error:', error)
    } finally {
      runInAction(() => {
        this.loadingReport = false
      })
    }
  }

  setCustomerId(customerId: string) {
    this.customerId = customerId
  }

  get customerOptions(): SelectOption[] {
    const options: SelectOption[] = []
    options.push(...this._customerStore.items.map(c => ({ label: c.name, value: c.id.toString() })))
    return options
  }

  setFrom(from?: Dayjs) {
    this.from = from
  }

  setTo(to?: Dayjs) {
    this.to = to
  }
  async loadData() {
    if (this.reportMode === GCStorageReportMode.InboundOrder) {
      const result = await ordersService.getFulfilledInboundOrders(
        this.customerId === 'All' ? undefined : parseInt(this.customerId),
        this.from?.toISOString(),
        this.to?.toISOString(),
      )

      runInAction(() => {
        this.inboundOrders = result
      })
    } else {
      const result = await ordersService.getStockInventory(
        this.customerId === 'All' ? undefined : parseInt(this.customerId),
        this.from?.toISOString(),
        this.to?.toISOString(),
      )
      runInAction(() => {
        this.stockInventories = result
      })
    }
  }

  resetFilter() {
    this.setFrom(undefined)
    this.setTo(undefined)
  }

  setIdsToSubmit(orderIds: number[]) {
    this.ordersToBePreBilled = orderIds
  }

  setReportMode(reportMode: GCStorageReportMode) {
    this.reportMode = reportMode
  }
}
